import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setModal } from "../features/modal/ModalSlice";
import { Box, Typography, Button, Container, Paper } from "@mui/material";

const Demo = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setModal({ type: "CALL_DIALPAD" }));
  }, []);

  return (
    <Container maxWidth="sm">
      <Paper elevation={3} sx={{ padding: 4, marginTop: 6 }}>
        <Typography variant="h4" align="center" gutterBottom>
          👋 Welcome to Dialgrid AI
        </Typography>
        <Typography variant="body1" align="center" paragraph>
          Experience our intelligent voice agent in action. Dialgrid AI is built to streamline
          VoIP-based communication—whether it's customer support, lead generation, or automated call
          handling.
        </Typography>
        <Typography variant="body2" align="center" color="text.secondary">
          The dialpad modal has been triggered to simulate a live call. Explore how our AI
          interacts, responds, and adapts in real time.
        </Typography>
        <Box textAlign="center" mt={4}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => dispatch(setModal({ type: "CALL_DIALPAD" }))}
          >
            Relaunch Dialpad
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default Demo;
